import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'

export interface HeadingColumnProps {
  icon: IconDefinition
  title: string
  className?: string
}

export function HeadingColumn({ icon, title, className }: HeadingColumnProps) {
  return (
    <div
      data-testid="headingColumn"
      className={twMerge(`bg-shades-25 border-shades-200 w-[125px] min-w-[125px] border-r p-6`, className)}
    >
      <FontAwesomeIcon icon={icon} className="text-shades-400 text-[22px]" />
      <p className="pt-[5px] text-[14px] font-bold">{title}</p>
    </div>
  )
}
